export default __webpack_public_path__ + "static/media/newDownload.4f9bbaed.svg";